<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01"><p class="c1"><span><br/>This book is for<br/>
Virginia Kidd,<br/>
one of the sweetest people ever to grace<br/>
the science fiction field.</span></p>
<p class="txt"> </p>
<p class="c1"><span>And for Kim,<br/>
my wonderful wife,<br/>
who makes everything possible.</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743420488_ded01.vue?a0872fc0